<app-audit-subbar></app-audit-subbar>

<div class="tab-chip-container">
  <button
    *ngFor="let t of tabs"
    class="tab-chip"
    [class.active]="selectedTab == t.key"
    (click)="selectedTab = t.key"
  >
    {{ t.label }}
  </button>
</div>

<app-seo *ngIf="selectedTab == 'seo'"></app-seo>
<app-geo *ngIf="selectedTab == 'geo'"></app-geo>
<app-agentic-ecommerce
  *ngIf="selectedTab == 'agenticEcommerce'"
></app-agentic-ecommerce>
